module.exports = __webpack_public_path__ + "img/people says.06e2d6c2.svg";